import type { HyroxEventName, HyroxEvents } from 'app/utils/analytics/types';
import { getRecordRelayClient } from 'app/utils/analytics/recordrelay/client';

export const trackEvent = <T extends HyroxEventName>(name: T, props: HyroxEvents[T]): void => {
  getRecordRelayClient()
    ?.emit(name, props as Record<string, unknown>)
    .catch(() => undefined);
};
